import React from "react";
import "../../App.css";
import Cards from "../Cards";
import GalleryPage from "../GalleryPages/GalleryPage";
export default function Gallery() {
  return (
    <>
      <div className="Gallery">
        {/* <Cards /> */}
        <GalleryPage />
      </div>
    </>
  );
}
